import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { recentBuyers } from '../data/landing';
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer: number;
    const show = () => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % recentBuyers.length);
      }, 4500);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 16000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, []);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-4 z-30 hidden sm:block" aria-live="polite" data-id="element-235" data-mp="f4dzmzyyn8rh">
      <AnimatePresence data-id="element-236" data-mp="b3230aho5n9s">
        {visible && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex items-center gap-3 rounded-2xl bg-white px-4 py-3 shadow-lift ring-1 ring-line" data-id="element-237" data-mp="1u6hs2zcxpi5p">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-teal text-white" data-id="element-238" data-mp="283wjuaqnu20u">
              <CheckIcon className="h-5 w-5" strokeWidth={3} aria-hidden data-id="element-239" data-mp="1fhl9w9h5yord" />
            </span>
            <div data-id="element-240" data-mp="1ff8rjv7hucds">
              <p className="text-sm font-extrabold text-ink" data-id="element-241" data-mp="1kgy6hlxu7a75">
                {buyer.name} from {buyer.place}
              </p>
              <p className="text-xs font-semibold text-inkSoft" data-id="element-242" data-mp="1p8g6o7s1d6r2">just got Maker Lab™ + 3 bonuses</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}